export default __webpack_public_path__ + "static/media/lafemalogo.829e7078.png";